module.exports = __webpack_public_path__ + "static/img/u3.6268ed4e.png";